var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenDoubleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72862 10.2385L17.6394 1.17188L16.3584 0.0542297L9.03995 8.44206L8.52735 7.93946L7.33716 9.15332L8.49305 10.2867L9.13632 10.9174L9.72862 10.2385ZM5.2153 10.2147L12.5594 1.14807L11.2384 0.0780423L4.48644 8.41368L1.7313 5.6767L0.533203 6.88275L3.95575 10.2827L4.62317 10.9458L5.2153 10.2147Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDoubleTick);
export default __webpack_public_path__ + "static/media/greenDoubleTick.415866cfaf2358dad57d9bed3fc4e57b.svg";
export { ForwardRef as ReactComponent };